
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top/[slug]",
      function () {
        return require("private-next-pages/top/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top/[slug]"])
      });
    }
  